import { EmblaCarouselType } from 'embla-carousel';
import { useCallback } from 'react';

import { styles } from './Arrows.styles';
const cursorUrlPrev = '/media/icons/arrow-circle-prev.svg';
const cursorUrlNext = '/media/icons/arrow-circle-next.svg';

type UsePrevNextButtonsType = {
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevNextButtons = (
  emblaApi: EmblaCarouselType | undefined,
  onButtonClick?: (emblaApi: EmblaCarouselType) => void
): UsePrevNextButtonsType => {
  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
    if (onButtonClick) onButtonClick(emblaApi);
  }, [emblaApi, onButtonClick]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
    if (onButtonClick) onButtonClick(emblaApi);
  }, [emblaApi, onButtonClick]);

  return {
    onPrevButtonClick,
    onNextButtonClick
  };
};

export interface ArrowsProps {
  className?: string;
  onClick?: () => void;
}

export function PrevButton({ ...props }: ArrowsProps) {
  const slots = styles({});

  return (
    <div
      className={slots.arrow({
        className: [slots.arrowPrev()]
      })}
      style={{
        cursor: `url(${cursorUrlPrev}), pointer`
      }}
      {...props}
    ></div>
  );
}

export function NextButton({ ...props }: ArrowsProps) {
  const slots = styles({});

  return (
    <div
      className={slots.arrow({
        className: [slots.arrowNext()]
      })}
      style={{
        cursor: `url(${cursorUrlNext}), pointer`
      }}
      {...props}
    ></div>
  );
}
